import React, { useState } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import EditIcon from '@material-ui/icons/Edit';
import {
    withStyles,
    Paper,
    Hidden,
    Toolbar,
    Tooltip,
    Typography,
    Button,
    Avatar,
    IconButton,
} from '@material-ui/core';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { Link } from 'react-router-dom';
import styles from './styles';
import ConfirmDialog from '../../ConfirmDialog';

function MembrosTable({
    classes,
    dadosGrupo,
    membros,
    idGrupoPequeno,
    idIgreja,
    handleRemoverItem,
}) {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [membroSelecionado, setMembroSelecionado] = useState(false);

    return (
        <Paper>
            <Paper className={classes.address} square elevation={1}>
                <Typography variant="h5">
                    DADOS DO GA
                    <IconButton
                        size="small"
                        component={Link}
                        to={`/atualizar_grupo/${idGrupoPequeno}`}
                    >
                        <EditIcon className={classes.iconSmall} />
                    </IconButton>
                </Typography>
                {(dadosGrupo.tipo == 1 ||
                    dadosGrupo.tipo == 3 ||
                    dadosGrupo.tipo == 4) && (
                        <Typography component="p" translate="no">{`${dadosGrupo.pastor}`}</Typography>
                    )}
                {(dadosGrupo.tipo == 1 ||
                    dadosGrupo.tipo == 3 ||
                    dadosGrupo.tipo == 4) && (
                        <Typography component="p" translate="no">{`${dadosGrupo.coordenador}`}</Typography>
                    )}
                <Typography variant="h5" className={classes.meet}>
                    REUNIÃO
                </Typography>
                <Typography component="p">{`${dadosGrupo.dia} ÀS ${dadosGrupo.horario}`}</Typography>
                <Typography component="p">
                    {`${dadosGrupo.endereco}, ${dadosGrupo.numero}, ${dadosGrupo.bairro}`}
                </Typography>
                <Typography component="p">
                    {`${dadosGrupo.latitude}, ${dadosGrupo.longitude}`}
                </Typography>
            </Paper>
            <Toolbar className={classes.toolbar}>
                <Tooltip title="Adicionar">
                    <Button
                        component={Link}
                        to={`/adicionar_membro/${idGrupoPequeno}/${idIgreja}`}
                        variant="outlined"
                        className={classes.buttonCriar}
                    >
                        <PersonAddIcon color="primary" />
                        <Typography
                            color="primary"
                            variant="body1"
                            component="span"
                        >
                            &nbsp;Adicionar Membro
                        </Typography>
                    </Button>
                </Tooltip>
            </Toolbar>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: '10px' }} />
                        <TableCell>Nome</TableCell>
                        <Hidden smDown>
                            <TableCell>
                                <span>Telefone</span>
                            </TableCell>
                        </Hidden>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {membros.map(row => (
                        <TableRow
                            hover
                            key={!!row.idMembro ? row.idMembro : row.id}
                        >
                            <TableCell
                                component={Link}
                                to={{
                                    pathname: `/membro/${idIgreja}/${row.idMembro}`,
                                }}
                            >
                                <Avatar
                                    className={classes.large}
                                    src={row.txFotoUrl}
                                />
                            </TableCell>
                            <TableCell
                                className={classes.tableCellNome}
                                scope="row"
                                align="left"
                                component={Link}
                                to={{
                                    pathname: `/membro/${idIgreja}/${row.idMembro}`,
                                }}
                            >
                                <span translate="no">{row.txMembro}</span>
                            </TableCell>
                            <Hidden smDown>
                                <TableCell align="left">
                                    {row.txTelefoneCel}
                                </TableCell>
                            </Hidden>
                            <TableCell align="center">
                                {row.tipo === 3 && (
                                    <IconButton
                                        onClick={() => {
                                            setConfirmOpen(true);
                                            setMembroSelecionado(row);
                                        }}
                                    >
                                        <RemoveCircleOutlineIcon />
                                    </IconButton>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <ConfirmDialog
                title="Remover do Grupo"
                open={confirmOpen}
                setOpen={setConfirmOpen}
                onConfirm={e => handleRemoverItem(e, membroSelecionado)}
            >
                {`Tem certeza que deseja remover `}<span translate="no">{membroSelecionado.txMembro}</span>{` do seu grupo?`}
            </ConfirmDialog>
        </Paper>
    );
}

export default withStyles(styles)(MembrosTable);
